import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
// get our fontawesome imports
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SweetAlert from "react-bootstrap-sweetalert";
import Header from "../../components/Header";
import LoadingScreen from "../components/LoadingScreen";

class WeddingEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weddorigin: [],
      backsound: [],
      username: "",
      namesuami: "",
      nameistri: "",
      tanggal: "",
      descheader: "",
      imgslide1: "",
      imgslide1url: "",
      imgslide2: "",
      imgslide2url: "",
      imgslide3: "",
      imgslide3url: "",
      title2: "",
      desc2: "",
      imgsuami: "",
      imgsuamiurl: "",
      imgistri: "",
      imgistriurl: "",
      fullnamesuami: "",
      fullnameistri: "",
      descsuami: "",
      descistri: "",
      title3: "",
      desc3: "",
      imglokasi: "",
      imglokasiurl: "",
      imgakad: "",
      imgakadurl: "",
      imgresepsi: "",
      imgresepsiurl: "",
      desclokasi: "",
      descakad: "",
      descresepsi: "",
      title4: "",
      desc4: "",
      nohp: "",
      youtubecode: "",
      template: "",
      isReady: false,
      alert: null,
      message: "",
      errors: [],
    };
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.onImageChange = this.onImageChange.bind(this);
    this.handleUpdateWedding = this.handleUpdateWedding.bind(this);
    this.hasErrorFor = this.hasErrorFor.bind(this);
    this.renderErrorFor = this.renderErrorFor.bind(this);
  }

  componentDidMount() {
    const wedUsername = this.props.match.params.username;
    axios
      .get(`${window.localhost}/wedding/getuser/${wedUsername}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        this.setState({
          weddorigin: response.data,
          username: response.data.username,
          namesuami: response.data.namesuami,
          nameistri: response.data.nameistri,
          tanggal: response.data.tanggal,
          descheader: response.data.descheader,
          imgslide1: response.data.imgslide1,
          imgslide2: response.data.imgslide2,
          imgslide3: response.data.imgslide3,
          title2: response.data.title2,
          desc2: response.data.desc2,
          imgsuami: response.data.imgsuami,
          imgistri: response.data.imgistri,
          fullnamesuami: response.data.fullnamesuami,
          fullnameistri: response.data.fullnameistri,
          descsuami: response.data.descsuami,
          descistri: response.data.descistri,
          title3: response.data.title3,
          desc3: response.data.desc3,
          imglokasi: response.data.imglokasi,
          imgakad: response.data.imgakad,
          imgresepsi: response.data.imgresepsi,
          desclokasi: response.data.desclokasi,
          descakad: response.data.descakad,
          descresepsi: response.data.descresepsi,
          title4: response.data.title4,
          desc4: response.data.desc4,
          nohp: response.data.nohp,
          youtubecode: response.data.youtubecode,
          template: response.data.template,
        });

        // Backsound
        axios
          .get(`${window.localhost}/backsound`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
            },
          })
          .then((res) => {
            this.setState({
              backsound: res.data,
              isReady: true,
            });
          });
      })
      .catch((error) => {
        console.log(error.response.data);
        this.props.history.push("/admin-wedding/login");
      });
  }

  handleFieldChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      this.setState({
        [event.target.name]: event.target.files[0],
      });
      console.log(URL.createObjectURL(event.target.files[0]));
    }
  };

  goToHome() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Success!"
        onConfirm={() => this.onSuccess()}
        onCancel={this.hideAlert()}
        timeout={2000}
        confirmBtnText="Oke Siap"
      >
        {this.state.message}
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  onSuccess() {
    this.props.history.push("/admin-wedding/index");
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  handleUpdateWedding(event) {
    event.preventDefault();

    const {
      imgslide1,
      imgslide2,
      imgslide3,
      imgsuami,
      imgistri,
      imglokasi,
      imgakad,
      imgresepsi,
      weddorigin,
      backsound,
    } = this.state;

    const formData = new FormData();
    formData.append("username", this.state.username);
    formData.append("namesuami", this.state.namesuami);
    formData.append("nameistri", this.state.nameistri);
    formData.append("tanggal", this.state.tanggal);
    formData.append("descheader", this.state.descheader);
    if (imgslide1 != weddorigin.imgslide1) {
      formData.append("imgslide1", imgslide1, imgslide1.name);
    } else {
      formData.append("imgslide1", imgslide1);
    }

    if (imgslide2 != weddorigin.imgslide2) {
      formData.append("imgslide2", imgslide2, imgslide2.name);
    } else {
      formData.append("imgslide2", imgslide2);
    }

    if (imgslide3 != weddorigin.imgslide3) {
      formData.append("imgslide3", imgslide3, imgslide3.name);
    } else {
      formData.append("imgslide3", imgslide3);
    }

    formData.append("title2", this.state.title2);
    formData.append("desc2", this.state.desc2);

    if (imgsuami != weddorigin.imgsuami) {
      formData.append("imgsuami", imgsuami, imgsuami.name);
    } else {
      formData.append("imgsuami", imgsuami);
    }

    if (imgistri != weddorigin.imgistri) {
      formData.append("imgistri", imgistri, imgistri.name);
    } else {
      formData.append("imgistri", imgistri);
    }

    formData.append("fullnamesuami", this.state.fullnamesuami);
    formData.append("fullnameistri", this.state.fullnameistri);
    formData.append("descsuami", this.state.descsuami);
    formData.append("descistri", this.state.descistri);
    formData.append("title3", this.state.title3);
    formData.append("desc3", this.state.desc3);

    if (imglokasi != weddorigin.imglokasi) {
      formData.append("imglokasi", imglokasi, imglokasi.name);
    } else {
      formData.append("imglokasi", imglokasi);
    }

    if (imgakad != weddorigin.imgakad) {
      formData.append("imgakad", imgakad, imgakad.name);
    } else {
      formData.append("imgakad", imgakad);
    }

    if (imgresepsi != weddorigin.imgresepsi) {
      formData.append("imgresepsi", imgresepsi, imgresepsi.name);
    } else {
      formData.append("imgresepsi", imgresepsi);
    }

    formData.append("desclokasi", this.state.desclokasi);
    formData.append("descakad", this.state.descakad);
    formData.append("descresepsi", this.state.descresepsi);
    formData.append("title4", this.state.title4);
    formData.append("desc4", this.state.desc4);
    formData.append("nohp", this.state.nohp);
    formData.append("youtubecode", this.state.youtubecode);
    formData.append("template", this.state.template);

    const weddingUsername = this.props.match.params.username;

    axios
      .post(`${window.localhost}/wedding/${weddingUsername}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        // redirect to the homepage
        var msg = response.data.success;
        if (msg == true) {
          this.setState({
            message: response.data.message,
          });
          return this.goToHome();
        }
      })
      .catch((error) => {
        // console.log(error.response.data);
        this.setState({
          errors: error.response.data,
        });
      });
  }

  hasErrorFor = (field) => {
    return !!this.state.errors[field];
  };

  renderErrorFor(field) {
    if (this.hasErrorFor(field)) {
      return (
        <span className="invalid-feedback">
          <strong>{this.state.errors[field][0]}</strong>
        </span>
      );
    }
  }

  render() {
    const { weddorigin, backsound } = this.state;
    const imgpath = `${window.localhost}/img`;
    if (!this.state.isReady) {
      return <LoadingScreen />;
    } else {
      return (
        <div className="bg-white">
          <Header />
          <div className="container-fluid pt-6 overflow-hidden">
            <div className="container my-4 py-3">
              <h2 className="fw-bold text-center">
                <div className="grey-line me-2"> </div>
                {this.state.namesuami}
                <FontAwesomeIcon icon={faHeart} className="fs-4 pink-heart" />
                <FontAwesomeIcon icon={faHeart} className="fs-4 grey-heart" />
                {this.state.nameistri}
                <div className="grey-line ms-2"> </div>
              </h2>
              {/* Edit Utama */}
              <div className="container rounded-4 p-3 p-sm-4">
                <form
                  onSubmit={this.handleUpdateWedding}
                  encType="multipart/form-data"
                >
                  <div className="row row-cols-1 row-cols-md-2 mb-3">
                    <div className="col">
                      <label htmlFor="username" className="form-label">
                        Username
                      </label>
                      <input
                        type="text"
                        id="username"
                        name="username"
                        value={this.state.username}
                        className={`form-control ${
                          this.hasErrorFor("username") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("username")}
                    </div>
                    <div className="col">
                      <label htmlFor="template" className="form-label">
                        Template
                      </label>
                      <select
                        id="template"
                        name="template"
                        value={this.state.template}
                        class={`form-select ${
                          this.hasErrorFor("template") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                        aria-label=".form-select example"
                      >
                        <option value="wedv1">Wedv1</option>
                        <option value="wedv2">Wedv2</option>
                        <option value="wedv3">Wedv3</option>
                      </select>
                      {this.renderErrorFor("template")}
                    </div>
                  </div>
                  <div className="row row-cols-1 row-cols-md-2 mb-3">
                    <div className="col">
                      <label htmlFor="namesuami" className="form-label">
                        Nama Panggilan Suami
                      </label>
                      <input
                        type="text"
                        id="namesuami"
                        name="namesuami"
                        value={this.state.namesuami}
                        className={`form-control ${
                          this.hasErrorFor("namesuami") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("namesuami")}
                    </div>
                    <div className="col">
                      <label htmlFor="nameistri" className="form-label">
                        Nama Panggilan Istri
                      </label>
                      <input
                        type="text"
                        id="nameistri"
                        name="nameistri"
                        value={this.state.nameistri}
                        className={`form-control ${
                          this.hasErrorFor("nameistri") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("nameistri")}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="tanggal" className="form-label">
                        Tanggal Pernikahan
                      </label>
                      <input
                        type="date"
                        id="tanggal"
                        name="tanggal"
                        value={this.state.tanggal}
                        className={`form-control ${
                          this.hasErrorFor("tanggal") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("tanggal")}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="descheader" className="form-label">
                        Deskripsi Heading
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="descheader"
                        name="descheader"
                        value={this.state.descheader}
                        className={`form-control ${
                          this.hasErrorFor("descheader") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("descheader")}
                    </div>
                  </div>

                  <div className="row row-cols-1 row-cols-md-3 mb-3">
                    <div className="col mb-3">
                      <img
                        src={
                          this.state.imgslide1 == weddorigin.imgslide1
                            ? `${imgpath}/${weddorigin.username}/${this.state.imgslide1}`
                            : ``
                        }
                        className="img-fluid rounded-4 mb-3"
                      />
                      <label htmlFor="imgslide1" className="form-label">
                        Gambar Slide 1
                      </label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/webp"
                        id="imgslide1"
                        name="imgslide1"
                        className={`form-control ${
                          this.hasErrorFor("imgslide1") ? "is-invalid" : ""
                        }`}
                        onChange={this.onImageChange}
                      />
                      {this.renderErrorFor("imgslide1")}
                    </div>
                    <div className="col mb-3">
                      <img
                        src={
                          this.state.imgslide2 == weddorigin.imgslide2
                            ? `${imgpath}/${weddorigin.username}/${this.state.imgslide2}`
                            : ``
                        }
                        className="img-fluid rounded-4 mb-3"
                      />
                      <label htmlFor="imgslide2" className="form-label">
                        Gambar Slide 2
                      </label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/webp"
                        id="imgslide2"
                        name="imgslide2"
                        className={`form-control ${
                          this.hasErrorFor("imgslide2") ? "is-invalid" : ""
                        }`}
                        onChange={this.onImageChange}
                      />
                      {this.renderErrorFor("imgslide2")}
                    </div>
                    <div className="col mb-3">
                      <img
                        src={
                          this.state.imgslide3 == weddorigin.imgslide3
                            ? `${imgpath}/${weddorigin.username}/${this.state.imgslide3}`
                            : ``
                        }
                        className="img-fluid rounded-4 mb-3"
                      />
                      <label htmlFor="imgslide3" className="form-label">
                        Gambar Slide 3
                      </label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/webp"
                        className="form-control"
                        id="imgslide3"
                        name="imgslide3"
                        className={`form-control ${
                          this.hasErrorFor("imgslide3") ? "is-invalid" : ""
                        }`}
                        onChange={this.onImageChange}
                      />
                      {this.renderErrorFor("imgslide3")}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="title2" className="form-label">
                        Sub-Judul Kedua
                      </label>
                      <input
                        type="text"
                        id="title2"
                        name="title2"
                        value={this.state.title2}
                        className={`form-control ${
                          this.hasErrorFor("title2") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("title2")}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="desc2" className="form-label">
                        Deskripsi Kedua
                      </label>
                      <textarea
                        id="desc2"
                        name="desc2"
                        value={this.state.desc2}
                        rows="3"
                        className={`form-control ${
                          this.hasErrorFor("desc2") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("desc2")}
                    </div>
                  </div>

                  <div className="row row-cols-1 row-cols-md-2 mb-3">
                    <div className="col mb-3">
                      <img
                        src={`${imgpath}/${weddorigin.username}/${this.state.imgsuami}`}
                        className="img-fluid rounded-4 mb-3"
                      />
                      <label htmlFor="imgsuami" className="form-label">
                        Foto Suami
                      </label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/webp"
                        id="imgsuami"
                        name="imgsuami"
                        className={`form-control ${
                          this.hasErrorFor("imgsuami") ? "is-invalid" : ""
                        }`}
                        onChange={this.onImageChange}
                      />
                      {this.renderErrorFor("imgsuami")}
                    </div>
                    <div className="col mb-3">
                      <img
                        src={
                          this.state.imgistri == weddorigin.imgistri
                            ? `${imgpath}/${weddorigin.username}/${this.state.imgistri}`
                            : ``
                        }
                        className="img-fluid rounded-4 mb-3"
                      />
                      <label htmlFor="imgistri" className="form-label">
                        Foto Istri
                      </label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/webp"
                        id="imgistri"
                        name="imgistri"
                        className={`form-control ${
                          this.hasErrorFor("imgistri") ? "is-invalid" : ""
                        }`}
                        onChange={this.onImageChange}
                      />
                      {this.renderErrorFor("imgistri")}
                    </div>
                  </div>

                  <div className="row row-cols-1 row-cols-md-2 mb-3">
                    <div className="col mb-3">
                      <label htmlFor="fullnamesuami" className="form-label">
                        Nama Lengkap Suami
                      </label>
                      <input
                        type="text"
                        id="fullnamesuami"
                        name="fullnamesuami"
                        value={this.state.fullnamesuami}
                        className={`form-control ${
                          this.hasErrorFor("fullnamesuami") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("fullnamesuami")}
                      <br />
                      <label htmlFor="descsuami" className="form-label">
                        Deskripsi Suami
                      </label>
                      <textarea
                        id="descsuami"
                        name="descsuami"
                        value={this.state.descsuami}
                        rows="3"
                        className={`form-control ${
                          this.hasErrorFor("descsuami") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("descsuami")}
                    </div>
                    <div className="col">
                      <label htmlFor="fullnameistri" className="form-label">
                        Nama Lengkap Istri
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="fullnameistri"
                        name="fullnameistri"
                        value={this.state.fullnameistri}
                        className={`form-control ${
                          this.hasErrorFor("fullnameistri") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("fullnameistri")}
                      <br />
                      <label htmlFor="descistri" className="form-label">
                        Deskripsi Istri
                      </label>
                      <textarea
                        className="form-control"
                        id="descistri"
                        name="descistri"
                        value={this.state.descistri}
                        rows="3"
                        className={`form-control ${
                          this.hasErrorFor("descistri") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("descistri")}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="title3" className="form-label">
                        Sub-Judul Ketiga
                      </label>
                      <input
                        type="text"
                        id="title3"
                        name="title3"
                        value={this.state.title3}
                        className={`form-control ${
                          this.hasErrorFor("title3") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("title3")}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="desc3" className="form-label">
                        Deskripsi Ketiga
                      </label>
                      <textarea
                        id="desc3"
                        name="desc3"
                        value={this.state.desc3}
                        rows="3"
                        className={`form-control ${
                          this.hasErrorFor("desc3") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("desc3")}
                    </div>
                  </div>

                  <div className="row row-cols-1 row-cols-md-3 mb-3">
                    <div className="col mb-3">
                      <img
                        src={`${imgpath}/${weddorigin.username}/${this.state.imglokasi}`}
                        className="img-fluid rounded-4 mb-3"
                      />
                      <label htmlFor="imglokasi" className="form-label">
                        Gambar Lokasi
                      </label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/webp"
                        id="imglokasi"
                        name="imglokasi"
                        className={`form-control ${
                          this.hasErrorFor("imglokasi") ? "is-invalid" : ""
                        }`}
                      />
                      {this.renderErrorFor("imglokasi")}
                      <br />
                      <label htmlFor="desclokasi" className="form-label">
                        Deskripsi Lokasi
                      </label>
                      <textarea
                        id="desclokasi"
                        name="desclokasi"
                        value={this.state.desclokasi}
                        rows="3"
                        className={`form-control ${
                          this.hasErrorFor("desclokasi") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("desclokasi")}
                    </div>
                    <div className="col mb-3">
                      <img
                        src={`${imgpath}/${weddorigin.username}/${this.state.imgakad}`}
                        className="img-fluid rounded-4 mb-3"
                      />
                      <label htmlFor="imgakad" className="form-label">
                        Gambar Akad
                      </label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/webp"
                        id="imgakad"
                        name="imgakad"
                        className={`form-control ${
                          this.hasErrorFor("imgakad") ? "is-invalid" : ""
                        }`}
                      />
                      {this.renderErrorFor("imgakad")}
                      <br />
                      <label htmlFor="descakad" className="form-label">
                        Deskripsi Akad
                      </label>
                      <textarea
                        id="descakad"
                        name="descakad"
                        value={this.state.descakad}
                        rows="3"
                        className={`form-control ${
                          this.hasErrorFor("descakad") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("descakad")}
                    </div>
                    <div className="col mb-3">
                      <img
                        src={`${imgpath}/${weddorigin.username}/${this.state.imgresepsi}`}
                        className="img-fluid rounded-4 mb-3"
                      />
                      <label htmlFor="imgresepsi" className="form-label">
                        Gambar Resepsi
                      </label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/webp"
                        id="imgresepsi"
                        name="imgresepsi"
                        className={`form-control ${
                          this.hasErrorFor("imgresepsi") ? "is-invalid" : ""
                        }`}
                      />
                      {this.renderErrorFor("imgresepsi")}
                      <br />
                      <label htmlFor="descresepsi" className="form-label">
                        Deskripsi Resepsi
                      </label>
                      <textarea
                        id="descresepsi"
                        name="descresepsi"
                        value={this.state.descresepsi}
                        rows="3"
                        className={`form-control ${
                          this.hasErrorFor("descresepsi") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("descresepsi")}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="title4" className="form-label">
                        Sub-Judul Keempat
                      </label>
                      <input
                        type="text"
                        id="title4"
                        name="title4"
                        value={this.state.title4}
                        className={`form-control ${
                          this.hasErrorFor("title4") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("title4")}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="desc4" className="form-label">
                        Deskripsi Keempat
                      </label>
                      <textarea
                        id="desc4"
                        name="desc4"
                        value={this.state.desc4}
                        rows="3"
                        className={`form-control ${
                          this.hasErrorFor("desc4") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("desc4")}
                    </div>
                  </div>

                  <div className="row row-cols-md-2 mb-3">
                    <div className="col">
                      <label htmlFor="nohp" className="form-label">
                        Nomor HP
                      </label>
                      <input
                        type="text"
                        id="nohp"
                        name="nohp"
                        value={this.state.nohp}
                        className={`form-control ${
                          this.hasErrorFor("nohp") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("nohp")}
                    </div>

                    <div className="col">
                      <label htmlFor="youtubecode" className="form-label">
                        Backsound
                      </label>
                      <select
                        id="youtubecode"
                        name="youtubecode"
                        value={this.state.youtubecode}
                        class={`form-select ${
                          this.hasErrorFor("youtubecode") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                        aria-label=".form-select example"
                      >
                        {backsound.map((bgsnd, i) => (
                          <option key={i} value={bgsnd.music_url}>
                            {bgsnd.music_name}
                          </option>
                        ))}
                      </select>

                      {this.renderErrorFor("youtubecode")}
                    </div>
                  </div>

                  <button type="submit" className="btn btn-primary me-3 px-4">
                    Submit
                  </button>

                  <Link to={`/admin-wedding/index`} className="btn btn-light">
                    Kembali
                  </Link>
                </form>
              </div>
              {/* End of Edit Utama */}
            </div>
          </div>
          {this.state.alert}
        </div>
      );
    }
  }
}

export default WeddingEdit;
